const STORAGE_KEY = 'hangrily_guest_sessions';
const MAX_FREE_SESSIONS = 3;
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

function getGuestData() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { sessions: [], weekStart: Date.now() };
    const data = JSON.parse(raw);
    // Reset if week has passed
    if (Date.now() - data.weekStart > WEEK_MS) {
      return { sessions: [], weekStart: Date.now() };
    }
    return data;
  } catch {
    return { sessions: [], weekStart: Date.now() };
  }
}

function saveGuestData(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function getGuestSessionCount() {
  return getGuestData().sessions.length;
}

export function getRemainingGuestSessions() {
  return Math.max(0, MAX_FREE_SESSIONS - getGuestData().sessions.length);
}

export function canStartGuestSession() {
  return getGuestData().sessions.length < MAX_FREE_SESSIONS;
}

export function recordGuestSession() {
  const data = getGuestData();
  data.sessions.push(Date.now());
  saveGuestData(data);
}

export function getGuestResetTime() {
  const data = getGuestData();
  const resetAt = data.weekStart + WEEK_MS;
  const diff = resetAt - Date.now();
  if (diff <= 0) return 'now';
  const days = Math.floor(diff / (24 * 60 * 60 * 1000));
  const hours = Math.floor((diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  if (days > 0) return `${days}d ${hours}h`;
  return `${hours}h`;
}

export const MAX_SESSIONS = MAX_FREE_SESSIONS;
